<template>
    <div class="accordion-item">
        <h2 class="accordion-header">
            <button
                type="button"
                class="accordion-button nav-link"
                :class="{collapsed: !isExpanded}"
                :aria-expanded="isExpanded"
                @click="toggle()"
            >
                <slot name="title">{{title}}</slot>
            </button>
        </h2>
        <div class="accordion-collapse collapse" :class="{show: isExpanded}">
            <div class="accordion-body">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import { Collapse } from 'bootstrap'
export default {
    props: {
        title: {
            type: String
        },
        expanded: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            isExpanded: this.expanded,
            collapse: null,
        }
    },

    mounted() {
        const node = this.$el.querySelector('.collapse')
        if (node) {
            this.collapse = new Collapse(node, {toggle: false})
        }
    },

    methods: {
        toggle() {
            this.isExpanded = !this.isExpanded
            this.collapse.toggle()
            this.$emit("expand", this.isExpanded)
        },
        show() {
            this.isExpanded = true
            this.collapse.show()
            this.$emit("expand", this.isExpanded)
        },
        hide() {
            this.isExpanded = false
            this.collapse.hide()
            this.$emit("expand", this.isExpanded)
        },
        set(expanded) {
            this.isExpanded = Boolean(expanded)
            if (expanded) {
                this.collapse.show()
            } else {
                this.collapse.hide()
            }
            // console.debug("EXP", expanded)
            this.$emit("expand", this.isExpanded)
        }
    }
}
</script>